export function integerFormatting(x) {
    if(x==="-") {
        return x;
    }
    if(!x) {
        return "";
    }
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");
}